<template>
  <div>
    <section class="section is-main-section">
      <card-component title="Project Form" icon="office-building" has-back>
        <form @submit.prevent="onSubmit">
          <b-field
            label="Project Info"
            horizontal
            :message="$v.name.msg"
            :type="$v.name.status"
          >
            <b-input placeholder="Name" v-model="form.name" />
          </b-field>
          <b-field horizontal>
            <b-input placeholder="Fingeprint" v-model="form.fingerprint" />
          </b-field>
          <hr />
          <b-field
            label="Project Specification"
            horizontal
            :message="$v.specification.msg"
            :type="$v.specification.status"
          >
            <b-field grouped>
              <b-field label="Perpetual" class="mr-6">
                <b-switch v-model="form.is_perpetual" label="Perpetual" />
              </b-field>
              <b-field label="Expiration Date" expanded>
                <b-input
                  type="date"
                  :disabled="form.is_perpetual"
                  v-model="form.specification.expiration_date"
                />
              </b-field>
            </b-field>
          </b-field>
          <b-field horizontal>
            <b-field label="Maximal Device">
              <b-input type="number" v-model="form.specification.max_device" />
            </b-field>
            <b-field label="Maximal User">
              <b-input type="number" v-model="form.specification.max_user" />
            </b-field>
            <b-field label="Maximal Zone">
              <b-input type="number" v-model="form.specification.max_zone" />
            </b-field>
          </b-field>
          <b-field horizontal>
            <b-field label="SMTP Mail">
              <b-switch v-model="form.specification.is_email" />
            </b-field>
            <b-field label="Mobile Access?">
              <b-switch v-model="form.specification.is_mobile" />
            </b-field>
          </b-field>
          <hr />
          <b-field
            v-if="drivers"
            custom-class="is-normal"
            label="Drivers"
            horizontal
          >
            <multiselect
              v-model="form.drivers"
              :options="drivers"
              multiple
              label="name"
              track-by="name"
            />
          </b-field>
          <hr />
          <b-field
            v-if="gateways"
            custom-class="is-normal"
            label="Gateways"
            horizontal
          >
            <multiselect
              v-model="form.gateways"
              :options="gateways"
              multiple
              label="name"
              track-by="name"
            />
          </b-field>
          <hr />
          <div ref="submit">
            <b-field horizontal>
              <b-button
                :loading="isLoading"
                expanded
                native-type="submit"
                type="is-primary"
              >
                Submit
              </b-button>
            </b-field>
          </div>
        </form>
      </card-component>
    </section>
  </div>
</template>

<script>
import formMixin from '@/mixins/form'
import validationMixin from '@/mixins/validation'

import { read as readDriver } from '@/api/driver'
import { read as readGateway } from '@/api/gateway'
import { read as readProject, create as createProject, update as updateProject } from '@/api/project'

import { required } from '@/utils/validation'
import dateUtil from '@/utils/date'

import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  mixins: [formMixin, validationMixin],
  created() {
    if (this.$route.params.project) {
      const {
        id,
        name,
        fingerprint,
        gateways,
        drivers,
        specification
      } = this.$route.params.project
      this.form = {
        id,
        name,
        fingerprint,
        gateways,
        drivers,
        specification: JSON.parse(specification),
      }
      const expDate = dateUtil(this.form.specification.expiration_date)
      this.form.specification.expiration_date = expDate.format('YYYY-MM-DD')
      if (expDate.valueOf() == 0) {
        this.form.is_perpetual = true
      }
    } else if (this.$route.params.id) {
      readProject(this.$route.params.id)
        .then(res => {
          this.form = res.data
          this.form.specification = JSON.parse(res.data.specification)
          const expDate = dateUtil(this.form.specification.expiration_date)
          this.form.specification.expiration_date = expDate.format('YYYY-MM-DD')
          if (expDate.valueOf() == 0) {
            this.form.is_perpetual = true
          }
        })
    }
    readDriver()
      .then(res => {
        this.drivers = res.data.drivers
      })
    readGateway()
      .then(res => {
        this.gateways = res.data.gateways
      })
  },
  data() {
    return {
      isLoading: false,
      drivers: [],
      gateways: [],
      rules: {
        name: [required],
        specification: [required]
      },
      form: {
        id: null,
        name: null,
        fingerprint: null,
        is_perpetual: false,
        specification: {
          expiration_date: dateUtil().format('YYYY-MM-DD'),
          max_device: 0,
          max_user: 0,
          max_zone: 0,
          is_mail: false,
          is_mobile: false
        },
        drivers: [],
        gateways: []
      }
    }
  },
  computed: {
    isUpdate() {
      return !!this.form.id
    }
  },
  methods: {
    submit() {
      if (this.form.is_perpetual) {
        this.form.specification.expiration_date = dateUtil(0)
      }
      this.form.specification.expiration_date = dateUtil(this.form.specification.expiration_date)
      this.form.specification.max_device = +this.form.specification.max_device
      this.form.specification.max_user = +this.form.specification.max_user
      this.form.specification.max_zone = +this.form.specification.max_zone

      if (this.isUpdate) {
        return updateProject(this.form)
          .then(() => {
            this.$router.back()
          })
      }
      return createProject(this.form)
        .then(() => {
          this.$router.back()
        })
    }
  }
}
</script>
